import { useCallback, useReducer } from "react";
import { CartConfigInterface, initialCartConfig } from "../CartTypes";
import { Action, ChangeEvents } from "../../Bundles/Types";

const useCartDrawerHook = () => {
    const cartConfigReducer = useCallback(
        (state: CartConfigInterface, action: Action<CartConfigInterface>): CartConfigInterface => {
            switch (action?.type) {
                case ChangeEvents.initState:
                    return { ...state, ...action.init };
                default:
                    if (action?.key && action.isComplex) {
                        return {
                            ...state,
                            [action?.key]: {
                                ...(state[action.key] as object),
                                ...(action.payload as object),
                            },
                        };
                    } else if (action?.key) return { ...state, [action?.key]: action.payload };
                    else return { ...state };
            }
        },
        [],
    );

    const [cartConfig, dispatchCartConfig] = useReducer(cartConfigReducer, initialCartConfig);

    return {
        cartConfig,
        dispatchCartConfig,
    };
};

export default useCartDrawerHook;
